import React from 'react'
import { createRoot } from 'react-dom/client'

import App from './App'
import { Provider } from 'reto'
import AppStorage from './Storages/AppStorage'

createRoot(document.getElementById('root')).render(
    <Provider of={AppStorage} memo>
      {console.log("App::start")}
      <App />
    </Provider>
)